export default __webpack_public_path__ + "static/media/coco-spinning.4a6536e5.gif";